import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { UserFacade } from '../../store/user/facade';
import { AuthService } from '../../core/services/auth-service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean> | Promise<boolean>;
}

@Injectable()
export class CanDeactivateGuard {
  private router = inject(Router);
  private authService = inject(AuthService);
  private userFacade = inject(UserFacade);

  canDeactivate(component: ComponentCanDeactivate): Observable<boolean> | boolean | Promise<boolean> {
    return component.canDeactivate && this.authService.isLoggedIn() ? component.canDeactivate() : true;
  }
}
